import { ArrowUpRight, Code2, Sparkles } from "lucide-react";
import { motion } from "framer-motion";

export const BCNEXT_URL = "https://www.bcnext.it/";

export const BcNextSection = () => (
  <section
    className="relative mx-auto max-w-[1400px] px-5 py-16 sm:px-10 sm:py-20"
    data-testid="bcnext-section"
    aria-label="Progettato e sviluppato da BC Next"
  >
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ duration: 0.7 }}
      className="overflow-hidden rounded-[28px] border border-[#E8E2E4] bg-white p-8 shadow-[0_14px_50px_rgba(94,42,82,0.08)] sm:p-12"
    >
      <div className="grid gap-10 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
        <div>
          <p className="inline-flex items-center gap-2 rounded-full bg-[#5E2A52]/8 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#5E2A52]">
            <Code2 size={13} /> Progettato e sviluppato da
          </p>
          <h2 className="mt-6 font-display text-4xl tracking-tight text-[#1A1617] sm:text-5xl">
            BC NEXT
          </h2>
          <p className="mt-2 font-display text-lg italic text-[#E0708A]">
            IT Consulting &amp; piattaforme digitali
          </p>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-[#6B5E62]">
            Questo progetto nasce dall'incontro tra una community di
            imprenditrici e un partner tecnologico che crede nelle stesse cose:
            identità curata, strumenti semplici, crescita misurabile. BC Next ha
            disegnato e sviluppato ogni dettaglio del sito — dall'identità
            visiva all'infrastruttura sicura — perché la voce di DonnaImpresa
            arrivi lontano.
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-4">
            <a
              href={BCNEXT_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="bcnext-section-cta"
              className="group inline-flex items-center gap-2 rounded-full bg-[#5E2A52] px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-[#E0708A]"
            >
              Scopri BC Next
              <ArrowUpRight
                size={16}
                className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </a>
            <a
              href={BCNEXT_URL}
              target="_blank"
              rel="noreferrer"
              className="di-underline text-sm text-[#5E2A52]"
              data-testid="bcnext-section-link"
            >
              bcnext.it
            </a>
          </div>
        </div>

        <ul className="grid gap-4">
          {[
            ["Identità e design", "Direzione creativa, tipografia e palette costruite su misura."],
            ["Sviluppo full-stack", "Sito veloce, sicuro e aggiornabile in autonomia."],
            ["Crescita digitale", "SEO, contenuti social e strumenti di misurazione."],
          ].map(([t, d]) => (
            <li
              key={t}
              className="rounded-2xl border border-[#E8E2E4] bg-[#FAF5F6] p-6 transition-transform duration-300 hover:-translate-y-1"
            >
              <p className="inline-flex items-center gap-2 font-display text-xl text-[#1A1617]">
                <Sparkles size={15} className="text-[#C9A227]" /> {t}
              </p>
              <p className="mt-2 text-sm leading-relaxed text-[#6B5E62]">{d}</p>
            </li>
          ))}
        </ul>
      </div>
    </motion.div>
  </section>
);
